module.exports = __webpack_public_path__ + "files/e535cdfc3923b72c3ef538b67e762dcd.png";